// src/components/EntrepreneursGrid.js
import React from 'react';
import EntrepreneurSkeleton from './EntrepreneurSkeleton';
import EntrepreneurCard from './EntrepreneurCard/EntrepreneurCard';
import Button from './Button/Button';

const EntrepreneursGrid = ({ entrepreneurs, loading, hasMore, loadMoreEntrepreneurs, onShowDetails }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {Array.from({ length: 10 }).map((_, index) => (
          <EntrepreneurSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (!entrepreneurs || entrepreneurs.length === 0) {
    return (
      <div className="bg-white rounded-2xl p-10 text-center border border-gray-200">
        <p className="text-lg font-semibold text-purple-refugia">
          Nenhum empreendedor encontrado com os filtros selecionados.
        </p>
        <p className="text-sm text-gray-500 mt-2">
          Tente limpar os filtros ou ajustar a busca.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {entrepreneurs.map((entrepreneur) => (
        <EntrepreneurCard
          key={entrepreneur.id}
          entrepreneur={entrepreneur}
          onShowDetails={onShowDetails}
        />
      ))}
      {hasMore && (
        <div className="flex justify-center mt-4 w-full col-span-full">
          <Button text="Carregar mais" variant="solid" onClick={loadMoreEntrepreneurs} />
        </div>
      )}
    </div>
  );
};

export default EntrepreneursGrid;
